// src/campaigns/constants/campaign-copy.ts

import { CampaignCopy } from "../types/campaign.types";

export const DEFAULT_CAMPAIGN_COPY: CampaignCopy = {
  heroEyebrow: "For love, healing & reconnection",
  heroTitle: "Express what matters,",
  heroTitleAccent: "more intentionally.",
  heroSubtitle:
    "Create private emotional moments for love, appreciation, forgiveness, celebration, healing, and the people who deserve to feel seen.",
  landingOccasions: [
    "For yourself.",
    "For family and friends.",
    "For love and appreciation.",
    "For healing and reconnection.",
    "For celebration.",
  ],

  modalTitle: "Make someone feel seen.",
  modalDescription: "Create a private LRNSY moment with words, feeling, and intention.",
  modalCTA: "Create a Moment",

  createCTA: "Make Someone Feel Seen",
  createHelperText:
    "Create something private, intentional, and meaningful for someone who matters.",

  loadingMessages: [
    "Preparing your experience...",
    "Choosing the right feeling...",
    "Making this moment intentional...",
  ],
  recipientLoadingMessages: [
    "Someone prepared something for you.",
    "A private moment is arriving.",
    "Take a breath before opening this.",
  ],

  recipientStartEyebrow: "A special moment awaits",
  recipientStartCTA: "Begin Experience",

  paymentHeadline: "Almost Ready to Share",
  paymentSubtitle: "Complete your payment to unlock the shareable link and deliver your love.",
  paymentCTA: "Unlock this moment",
  paymentSummaryTitle: "Payment Summary",
  paymentSecureNote: "By completing this payment, you agree to our Terms of Service",
  paymentLoadingMessage: "Calculating your payment...",
  paymentRedirectMessage: "Preparing your gift...",

  shareHeadline: "Your moment is ready.",
  shareSubtitle: "Copy the private link and send it to the person you chose.",
  shareMessage: "I've prepared something special for you on LRNSY.",
  sharePrivateLinkLabel: "Private Link",
  shareViaLabel: "Share via",
  sharePreviewLabel: "Preview",
  shareCreateNewCTA: "Create New",

  replyPrompt: "Before you leave this moment, write something back.",
  replyHelperText: "Even a few words can mean everything.",

  completionHeadline: "This moment found you.",
  completionSubtitle: "Someone chose to make this moment for you.",
  completionCTA: "Create Someone’s Moment",
  replayCTA: "Relive This Moment",
};

export function mergeCampaignCopy(copy: Partial<CampaignCopy>): CampaignCopy {
  return {
    ...DEFAULT_CAMPAIGN_COPY,
    ...copy,
    landingOccasions:
      copy.landingOccasions && copy.landingOccasions.length > 0
        ? copy.landingOccasions
        : DEFAULT_CAMPAIGN_COPY.landingOccasions,
    loadingMessages:
      copy.loadingMessages && copy.loadingMessages.length > 0
        ? copy.loadingMessages
        : DEFAULT_CAMPAIGN_COPY.loadingMessages,
    recipientLoadingMessages:
      copy.recipientLoadingMessages && copy.recipientLoadingMessages.length > 0
        ? copy.recipientLoadingMessages
        : DEFAULT_CAMPAIGN_COPY.recipientLoadingMessages,
  };
}
